// extracted by mini-css-extract-plugin
export default {"input_Container":"input_input_Container__dE3DL","input_btn":"input_input_btn__x-xk2","input_text":"input_input_text__KD3cT"};